/* Collett v3 — gedrag voor de homepage.
   Alles animeert uitsluitend transform en opacity, zodat CLS 0 blijft.
   Respecteert prefers-reduced-motion: dan staat alles stil en verschijnt
   alles direct.                                                            */
(() => {
  'use strict';

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const rust = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- mededelingenbalk: elke 4000 ms een regel ---------- */
  const balk = $('#balk');
  if (balk && balk.children.length > 1) {
    const regels = [...balk.children];
    let i = 0;
    const draai = () => {
      if (document.hidden) return;
      const oud = regels[i];
      i = (i + 1) % regels.length;
      oud.removeAttribute('data-nu');
      oud.setAttribute('data-weg', '');
      regels[i].setAttribute('data-nu', '');
      setTimeout(() => oud.removeAttribute('data-weg'), 600);
    };
    if (!rust) setInterval(draai, 4000);
  }

  /* ---------- kop verbergen bij omlaag scrollen ---------- */
  const kop = $('#kop');
  if (kop) {
    let vorige = window.scrollY;
    let bezig = false;
    addEventListener('scroll', () => {
      if (bezig) return;
      bezig = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const delta = y - vorige;
        /* data-weg verbergt de kop; data-kop-weg op <body> is het signaal
           waar de CSS van de filterbalk op wacht (body:not([data-kop-weg])).
           Zonder die tweede stond de balk altijd op top:var(--kop) te zweven,
           ook als de kop allang weggeschoven was, met een strook inhoud
           erboven. De twee horen altijd samen aan of uit te staan. */
        const weg = y > 140 && delta > 6;
        const terug = delta < -6 || y <= 140;
        if (weg) {
          kop.setAttribute('data-weg', '');
          document.body.setAttribute('data-kop-weg', '');
        } else if (terug) {
          kop.removeAttribute('data-weg');
          document.body.removeAttribute('data-kop-weg');
        }
        vorige = y;
        bezig = false;
      });
    }, { passive: true });
  }

  /* ---------- hero: overvloeien, voortgang, pauze ---------- */
  const hero = $('#hero');
  if (hero) {
    const beelden = $$('.hero__beelden img', hero);
    const streepjes = $$('.hero__voortgang i', hero);
    const pauzeKnop = $('#pauze', hero);
    let actief = 0, timer = null, gepauzeerd = rust;

    const toon = (n) => {
      beelden.forEach((b, k) => b.toggleAttribute('data-nu', k === n));
      streepjes.forEach((s, k) => {
        s.toggleAttribute('data-nu', k === n);
        s.toggleAttribute('data-gedaan', k < n);
      });
      actief = n;
    };

    const start = () => {
      clearInterval(timer);
      if (gepauzeerd || beelden.length < 2) return;
      timer = setInterval(() => toon((actief + 1) % beelden.length), 6000);
    };

    if (pauzeKnop) {
      pauzeKnop.addEventListener('click', () => {
        gepauzeerd = !gepauzeerd;
        hero.toggleAttribute('data-pauze', gepauzeerd);
        pauzeKnop.setAttribute('aria-label', gepauzeerd ? 'Beelden afspelen' : 'Beelden pauzeren');
        const ico = $('#pauzeIco', pauzeKnop);
        if (ico) ico.innerHTML = gepauzeerd ? '<path d="M3 1l8 5-8 5z"/>' : '<path d="M2 1h3v10H2zM7 1h3v10H7z"/>';
        start();
      });
    }
    if (rust) hero.setAttribute('data-pauze', '');
    document.addEventListener('visibilitychange', () => document.hidden ? clearInterval(timer) : start());
    start();
  }

  /* ---------- winkelstatus in Europe/Amsterdam ---------- */
  const DAGCODES = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];

  const nuInAmsterdam = () => {
    const d = new Date();
    const p = new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(d).reduce((a, x) => (a[x.type] = x.value, a), {});
    /* weekday geeft 'ma'..'zo' in nl-NL; normaliseren naar index */
    const kort = (p.weekday || '').toLowerCase().replace('.', '').slice(0, 2);
    const dag = Math.max(0, DAGCODES.indexOf(kort));
    return { dag, minuten: (+p.hour) * 60 + (+p.minute) };
  };

  const leesRooster = (tekst) => {
    const uit = {};
    (tekst || '').split(String.fromCharCode(10)).forEach((regel) => {
      const d = regel.trim().split('|').map((x) => x.trim());
      if (!d[0]) return;
      const i = DAGCODES.indexOf(d[0].toLowerCase());
      if (i < 0) return;
      if (d.length >= 3 && d[1] && d[2]) uit[i] = [d[1], d[2]];
    });
    return uit;
  };

  const naarMin = (t) => { const [u, m] = t.split(':').map(Number); return u * 60 + (m || 0); };

  const bepaalStatus = (rooster, nu) => {
    const vandaag = rooster[nu.dag];
    if (vandaag) {
      const o = naarMin(vandaag[0]), d = naarMin(vandaag[1]);
      if (nu.minuten >= o && nu.minuten < d) {
        return { open: true, kort: `Nu open · tot ${vandaag[1]}` };
      }
      if (nu.minuten < o) return { open: false, kort: `Nu gesloten · open om ${vandaag[0]}` };
    }
    /* eerstvolgende open dag zoeken */
    for (let i = 1; i <= 7; i++) {
      const dag = (nu.dag + i) % 7;
      if (rooster[dag]) {
        const naam = i === 1 ? 'morgen' : ['zondag','maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag'][dag];
        return { open: false, kort: `Nu gesloten · ${naam} vanaf ${rooster[dag][0]}` };
      }
    }
    return { open: false, kort: 'Nu gesloten' };
  };

  const nu = nuInAmsterdam();

  /* per winkelkaart */
  const winkels = $$('[data-winkel]');
  winkels.forEach((w) => {
    const st = bepaalStatus(leesRooster(w.dataset.rooster), nu);
    const houder = $('[data-status]', w);
    if (!houder) return;
    houder.toggleAttribute('data-dicht', !st.open);
    /* In de kaarten zit de stip binnen [data-status]; in de menulade staat hij
       ernaast, omdat het raster daar een eigen kolom voor hem heeft. */
    const stip = $('.stip', houder) || $('.stip', w);
    if (stip) stip.toggleAttribute('data-open', st.open);
    const tekst = houder.querySelector('span:last-child');
    if (tekst) tekst.textContent = st.kort;
    /* vandaag uitlichten in het weekrooster */
    $$('li[data-dag]', w).forEach((li) => {
      if (+li.dataset.dag === nu.dag) {
        li.setAttribute('data-vandaag', '');
        const naam = li.querySelector('span');
        if (naam && !/vandaag/.test(naam.textContent)) naam.textContent += ' (vandaag)';
      }
    });
  });

  /* Samenvattende statusregel. Staat op de hero (#heroStatus) en boven aan
     de contactpagina (#nu); beide tonen hetzelfde, uit dezelfde roosters. */
  const statusEl = $('#heroStatus') || $('#nu');
  if (statusEl && winkels.length) {
    /* Elke winkel telt één keer. [data-winkel] staat namelijk twee keer op een
       pagina: op de winkelkaarten én in de menulade, die dezelfde drie winkels
       herhaalt. Zonder deze stap stond er "4 van 6 winkels nu open" terwijl
       Collett er drie heeft (Jarno, 22-10-2026).

       Eerst de kopieën uit de lades eruit; blijft er niets over, dan is de
       lade de enige bron en wordt daar op naam ontdubbeld. Op naam en niet op
       rooster, want Hinthamerstraat en Hooge Steenweg hebben precies dezelfde
       openingstijden. */
    const naamVan = (w) => {
      const el = w.querySelector('h3, b');
      return ((el || {}).textContent || '').trim().toLowerCase();
    };
    let bronnen = winkels.filter((w) => !w.closest('.laag'));
    if (!bronnen.length) bronnen = winkels;
    const gezien = new Set();
    const standen = [];
    bronnen.forEach((w) => {
      const naam = naamVan(w);
      if (naam && gezien.has(naam)) return;
      if (naam) gezien.add(naam);
      standen.push({ naam: naam, st: bepaalStatus(leesRooster(w.dataset.rooster), nu) });
    });
    const open = standen.filter((x) => x.st.open);
    const stip = $('.stip', statusEl);
    const tekst = statusEl.querySelector('span:last-child');
    if (stip) stip.toggleAttribute('data-open', open.length > 0);
    if (tekst) {
      tekst.textContent = open.length
        ? `${open.length} van ${standen.length} winkels nu open`
        : standen[0].st.kort;
    }
  }

  /* ---------- voetkolommen ----------
     Ze staan open in de HTML, zodat de links er ook zonder JavaScript zijn, en
     worden hier onder 700px dichtgeklapt tot een accordeon. Andersom kan niet:
     de browser verbergt de inhoud van een dichte <details> zelf en daar komt
     geen media-query tussen. */
  const voetgroepen = $$('.vg');
  if (voetgroepen.length) {
    const breed = matchMedia('(min-width:700px)');
    const zetVoet = () => voetgroepen.forEach((g) => { g.open = breed.matches; });
    zetVoet();
    breed.addEventListener('change', zetVoet);
  }

  /* ---------- onthullen bij scrollen ---------- */
  const teOnthullen = $$('[data-onthul]');
  if (teOnthullen.length) {
    if (rust) {
      teOnthullen.forEach((e) => e.classList.add('zichtbaar'));
    } else {
      const io = new IntersectionObserver((lijst) => {
        lijst.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('zichtbaar'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -7% 0px' });
      teOnthullen.forEach((e) => {
        /* boven de vouw meteen tonen, anders flikkert de eerste sectie */
        if (e.getBoundingClientRect().top < innerHeight * 0.9) e.classList.add('zichtbaar');
        else io.observe(e);
      });
    }
  }

  /* ---------- merkenrij: voortgangsbalk ---------- */
  const rij = $('#merkrij'), vg = $('#merkvg');
  if (rij && vg) {
    const meet = () => {
      const max = rij.scrollWidth - rij.clientWidth;
      const deel = max > 0 ? rij.scrollLeft / max : 0;
      vg.style.transform = `translateX(${deel * (100 / 0.3 - 100)}%)`;
    };
    rij.addEventListener('scroll', meet, { passive: true });
    meet();
  }

  /* ---------- maatchips + FLIP-filtering ---------- */
  let huidigeGroep = 'a';
  /* Twee haakjes die het tabblad hieronder nodig heeft: de maatkeuze wissen en
     opnieuw filteren. Ze worden gevuld zodra er een raster is. */
  let wisMaatkeuze = null;
  let filterOpnieuw = null;
  const raster = $('[id^="raster-"]');
  if (raster) {
    const kaarten = () => $$('[data-kaart]', raster);
    const stand = $('[id^="stand-"]');
    /* Bewust niet de onthouden maat uit localStorage: deze rij stond daardoor
       meteen gefilterd op bijvoorbeeld maat 40, met een regel erboven die dat
       uitlegde. Een geselecteerde sectie op de homepage hoort te laten zien wat
       er gekozen is, niet wat er in jouw maat toevallig ligt (Jarno,
       22-10-2026). Tikt iemand hier zelf een maatchip aan, dan filtert hij
       alsnog. */
    let maat = null;

    const zetStand = (zichtbaar, totaal) => {
      if (!stand) return;
      stand.textContent = maat
        ? `${zichtbaar} van ${totaal} paren in maat ${maat}`
        : '';
    };

    const pasToe = () => {
      const lijst = kaarten();
      /* FLIP stap 1: posities meten vóór de wijziging */
      const voor = new Map();
      lijst.forEach((k) => voor.set(k, k.getBoundingClientRect().top + 'x' + k.getBoundingClientRect().left));

      let zichtbaar = 0;
      lijst.forEach((k) => {
        const inGroep = (k.dataset.groep || 'a') === huidigeGroep;
        const heeft = inGroep && (!maat || (k.dataset.maten || '').split(',').some((m) => m.trim() === maat));
        k.hidden = !heeft;
        if (heeft) zichtbaar++;
        const regel = k.querySelector('[data-matenregel]');
        if (regel) regel.classList.toggle('kaart__maten--jouw', !!maat && heeft);
      });
      const inGroepTotaal = lijst.filter((k) => (k.dataset.groep || 'a') === huidigeGroep).length;
      zetStand(zichtbaar, inGroepTotaal);

      if (rust) return;
      /* FLIP stap 2: alleen transform animeren, nooit layout */
      requestAnimationFrame(() => {
        lijst.forEach((k) => {
          if (k.hidden) return;
          const oud = voor.get(k);
          if (!oud) return;
          const r = k.getBoundingClientRect();
          const [ot, ol] = oud.split('x').map(Number);
          const dx = ol - r.left, dy = ot - r.top;
          if (!dx && !dy) return;
          k.style.transition = 'none';
          k.style.transform = `translate(${dx}px, ${dy}px)`;
          requestAnimationFrame(() => {
            k.style.transition = 'transform .52s cubic-bezier(.2,.8,.2,1)';
            k.style.transform = '';
          });
        });
      });
    };

    filterOpnieuw = pasToe;
    wisMaatkeuze = () => {
      maat = null;
      try { localStorage.removeItem('collett.maat'); } catch (e) {}
      $$('[data-maatchip]').forEach((c) => c.setAttribute('aria-pressed', 'false'));
    };

    $$('[data-maatchip]').forEach((chip) => {
      if (chip.dataset.maatchip === maat) chip.setAttribute('aria-pressed', 'true');
      chip.addEventListener('click', () => {
        const nieuw = chip.dataset.maatchip;
        maat = (maat === nieuw) ? null : nieuw;
        $$('[data-maatchip]').forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.maatchip === maat)));
        try { maat ? localStorage.setItem('collett.maat', maat) : localStorage.removeItem('collett.maat'); } catch (e) {}
        pasToe();
      });
    });

    if (maat) pasToe();
  }

  /* ---------- tabs ---------- */
  const tabs = $('.tabs');
  if (tabs) {
    const glijder = $('.tabs__glijder', tabs);
    const knoppen = $$('[role=tab]', tabs);
    const zetGlijder = () => {
      const aan = tabs.querySelector('[aria-selected="true"]');
      if (aan && glijder) {
        glijder.style.width = aan.offsetWidth + 'px';
        glijder.style.transform = `translateX(${aan.offsetLeft - 3}px)`;
      }
    };
    const kies = (soort, focus) => {
      knoppen.forEach((t) => {
        const aan = t.dataset.soort === soort;
        t.setAttribute('aria-selected', String(aan));
        t.tabIndex = aan ? 0 : -1;
        if (aan && focus) t.focus();
      });
      /* Alleen de kaarten van dit raster. Stond hier eerst zonder bereik, en
         dan verdween ook elke kaart elders op de pagina die geen data-groep
         heeft — bijvoorbeeld de hele Silhouetten-sectie. */
      $$('[data-kaart]', raster || document).forEach((k) => {
        k.hidden = (k.dataset.groep || 'a') !== soort;
      });
      huidigeGroep = soort;

      /* Sneakers en kleding hebben andere maten, dus de balk wisselt mee en de
         keuze vervalt: filteren op maat 42 slaat nergens op bij een longsleeve. */
      const balken = $$('[data-maatgroep]');
      if (balken.length) {
        balken.forEach((b) => { b.hidden = b.dataset.maatgroep !== soort; });
        const balk = $('.maatbalk');
        if (balk) balk.hidden = !balken.some((b) => b.dataset.maatgroep === soort && b.children.length);
      }
      if (wisMaatkeuze) wisMaatkeuze();
      if (filterOpnieuw) filterOpnieuw();

      zetGlijder();
    };
    knoppen.forEach((t, i) => {
      t.addEventListener('click', () => kies(t.dataset.soort, false));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + knoppen.length) % knoppen.length;
        kies(knoppen[n].dataset.soort, true);
      });
    });
    zetGlijder();
    addEventListener('resize', zetGlijder, { passive: true });
  }
})();
